module.exports = __webpack_public_path__ + "static/media/motorhome_republic_logo.464c7830.png";